/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
import { MapTo, Container } from '@adobe/aem-react-editable-components';
import '../../libs/aemComponents/Container';
import '../../libs/aemComponents/ExperienceFragment';
import {
  NavigationContainerWrapper,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
} from '@marriott/mi-common-static-components';
import { StaticWrapper } from '@marriott/mi-trc-components';
import { RFPComponent } from '@marriott/mi-trc-components';
import { FlyoutDrawer } from '@marriott/mi-book-components';
import { AccountContainerEditable, SignInEditable, SignInContentBlockEditable } from '@marriott/mi-account-components';
import { respGridUtil } from '@marriott/mi-headless-utils';

MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/reference/v1/reference`)(StaticWrapper, {
  emptyLabel: 'StaticWrapper',
  isEmpty: false,
});

MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/rfp/v1/rfp-meetings`)(RFPComponent, {
  emptyLabel: 'RFPComponent',
  isEmpty: false,
});

MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/rfp/v1/rfp-weddings`)(RFPComponent, {
  emptyLabel: 'RFPComponent',
  isEmpty: false,
});

MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/static-wrapper/v1/static-wrapper`)(StaticWrapper, {
  emptyLabel: 'StaticWrapper',
  isEmpty: false,
});

MapTo(`mi-aem-homepage-spa/components/content/global-navigation`)(
  props => <NavigationContainerWrapper {...props} isAuthorMode={isAuthorMode} />,
  {
    emptyLabel: 'NavigationContainerWrapper',
    isEmpty: false,
  }
);

MapTo(`mi-aem-homepage-spa/components/content/utilityNavigation`)(NavigationUtilityLinkWrapper, {
  emptyLabel: 'NavigationUtilityLinkWrapper',
  isEmpty: false,
});

MapTo(`mi-aem-homepage-spa/components/content/primaryNavigation`)(NavigationWrapper, {
  emptyLabel: 'NavigationWrapper',
  isEmpty: false,
});

MapTo(`mcom-book-spa/components/flyoutcontainer`)(props => <FlyoutDrawer {...props.model} {...props} />, {
  emptyLabel: 'FlyoutDrawer',
  isEmpty: false,
});
MapTo(`mi-aem-account/components/content/accountcontainer`)(props => <AccountContainerEditable {...props} />, {
  emptyLabel: 'accountcontainer',
  isEmpty: false,
});
MapTo(`mi-aem-account/components/content/signin`)(props => <SignInEditable {...props} />, {
  emptyLabel: 'signin',
});
MapTo(`mi-aem-account/components/content/signincontentblock`)(props => <SignInContentBlockEditable {...props} />, {
  emptyLabel: 'signincontentblock',
});
const DataPageVariationConfig = {
  emptyLabel: 'Data Page',

  isEmpty: function (props) {
    return !props || !props.configured;
  },
};
MapTo('mi-aem-account/components/content/datapagecomponent')(props => {
  const gridItems = props?.model?.cqItems?.responsivegrid?.[':items'];
  const isAccountContainer = gridItems ? Object.keys(gridItems)?.[0]?.includes('accountcontainer') : false;

  return (
    <Container
      isInEditor
      {...props}
      isPage={false}
      model={isAccountContainer ? respGridUtil(props?.model?.cqItems?.responsivegrid) : props?.model}
    />
  );
}, DataPageVariationConfig);
